import React from 'react';
import { View, Text, Pressable } from 'react-native';
import theme from '../../../theme';

export default function AgentsPricingHero({ period, onPeriodChange }) {
  return (
    <View style={{ paddingTop: 64, paddingHorizontal: 48, maxWidth: 720, width: '100%', alignSelf: 'center', alignItems: 'center' }}>
      <Text style={{
        fontFamily: theme.typography.fontDisplay,
        fontWeight: theme.typography.weight.regular,
        fontSize: theme.typography.size['3xl'],
        letterSpacing: theme.trackingPx(theme.typography.size['3xl'], 'tight'),
        textAlign: 'center',
        marginBottom: 16,
      }}>
        Simple, usage-based pricing
      </Text>
      <Text style={{
        fontFamily: theme.typography.fontSans,
        fontSize: theme.typography.size.md,
        color: theme.colors.textSecondary,
        lineHeight: theme.lineHeightPx(theme.typography.size.md, 'normal'),
        textAlign: 'center',
        marginBottom: 32,
      }}>
        One plan for teams, one for scale — pay for the queries you run.
      </Text>
      <View style={{
        flexDirection: 'row',
        borderWidth: theme.borderWidth.thin,
        borderColor: theme.colors.borderDefault,
        borderRadius: theme.radii.full,
        padding: 3,
      }}>
        {['monthly', 'annual'].map((p) => {
          const active = period === p;
          return (
            <Pressable
              key={p}
              onPress={() => onPeriodChange(p)}
              style={{
                paddingVertical: 8,
                paddingHorizontal: 20,
                borderRadius: theme.radii.full,
                backgroundColor: active ? theme.colors.gray950 : 'transparent',
              }}
            >
              <Text style={{
                fontFamily: theme.typography.fontSans,
                fontSize: theme.typography.size.sm,
                color: active ? theme.colors.textInverse : theme.colors.textSecondary,
              }}>
                {p === 'monthly' ? 'Monthly' : 'Annual — save 20%'}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
}